export default function inRangeCAR(original, modified, rangeRuleStatus) {
  if (rangeRuleStatus === 0) {
    return modified > 0
  }

  return parseInt(modified) >= original
}
